import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {provideTranslateService} from "@ngx-translate/core";


import { HeaderModule } from './header/header.module';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { LoginModule } from './login/login.module';

import { AppRoutingModule } from './app-routing.module';
import { OwnershipTransferModule } from './ownership-transfer/ownership-transfer.module';
import { IntlModule } from '@progress/kendo-angular-intl';

import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/fr/all';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CoreModule.forRoot(),
        NgbModule,
        SharedModule,
        HeaderModule,
        IntlModule,
        LoginModule,
        RouterModule,
        OwnershipTransferModule,

        AppRoutingModule,
    ],
    providers: [{
            provide: LOCALE_ID,
            useValue: 'en-US',
        },
        provideTranslateService()
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
